// /* global THREE */
import aframe from 'aframe';
import { bindEvent } from 'aframe-event-decorators';

/* Ensures that the active camera entity's position and rotation is reset when the user enters vr mode. Otherwise the wasd controls
 * can put the camera in a strange position before vr mode is entered.
 */
aframe.registerComponent("set-headset-to-origin", {
  enterVr: bindEvent({ target: "a-scene", event: "enter-vr" }, function () {
    const camera = this.el.sceneEl.camera.el;
    camera.setAttribute("position", "0 0 0");
  }),
  exitVr: bindEvent({ target: "a-scene", event: "exit-vr" }, function () {
    // Do nothing
  })
});
